<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-information-symbol</v-icon>
              <div class="d-flex flex-column align-start flex-grow-1">
								<p class="mb-0 font-weight-bold text-primary title">Datos de Facturación</p>
								<p class="mb-0 text-primary caption">Por favor ingresa los datos con los que quieres que las empresas te facturen los proyectos.</p>
              </div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-1">
                <v-col cols="12">
									<v-btn-toggle
										v-model="selectedTab"
										dense
										class="d-flex flex-row custom-toggle-btns"
									>
										<v-btn :value="1" class="flex-grow-1"
											:color="selectedTab == 1 ? '#FF1209':''">
											<p class="mb-0 caption font-weight-bold" :class="selectedTab == 1 ? 'white--text':'text-primary'">Datos de Facturación</p>
										</v-btn>
										<v-btn :value="2" class="flex-grow-1"
											:color="selectedTab == 2 ? '#FF1209':''">
											<p class="mb-0 caption font-weight-bold" :class="selectedTab == 2 ? 'white--text':'text-primary'">Datos de Transferencia</p>
										</v-btn>
									</v-btn-toggle>
								</v-col>
							</v-row>
							<div class="pa-4" v-if="selectedTab == 1">
								<v-row class="mb-4 mt-2">
									<v-col cols="12" class="py-0">
										<div class="d-flex justify-space-between align-center flex-1 pa-2 mb-4" style="border: 1px solid #959595;border-radius: 5px;">
											<p class="mb-0">Tipo de Facturación: <b>{{newBillingInfo.type ? 'Empresa':'Persona Natural'}}</b></p>
											<v-switch
												class="mt-0"
												color="#FF120B"
												dense
												hide-details
												v-model="newBillingInfo.type"
											></v-switch>
										</div>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newBillingInfo.name"
											label="Nombre Legal (SII)"
											:placeholder="newBillingInfo.type ? 'Ingrese el nombre legal de la empresa':'Ingrese su nombre'"
											outlined
											required
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newBillingInfo.rut"
											label="Rut"
											placeholder="Ingrese el rut"
											outlined
											required
											dense
											hint="Ingresa rut sin puntos ni guión"
											:rules="rutRule"
											@blur="onBlurRut"
											@focus="onFocusRut"
											maxlength="9"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newBillingInfo.address"
											label="Dirección"
											placeholder="Ingrese direccción completa"
											outlined
											required
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-select
											v-model="newBillingInfo.state_id"
											:items="$store.state.general.states"
											:loading="$store.state.general.loadingStates"
											:menu-props="{ top: true, offsetY: true }"
											item-text="name"
											item-value="id"
											label="Seleccione Región"
											outlined
											dense
											required
											:rules="requiredRule"
											@change="onChangeState"
										></v-select>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-select
											v-model="newBillingInfo.district_id"
											:items="$store.state.general.cities"
											:loading="$store.state.general.loadingCities"
											item-text="name"
											item-value="id"
											label="Seleccione Comuna"
											outlined
											dense
											required
											:disabled="!newBillingInfo.state_id"
											:rules="requiredRule"
										></v-select>
									</v-col>
								</v-row>
							</div>
							<div class="px-4 py-1" v-if="selectedTab == 2">
								<p class="mb-0 font-weight-bold">Datos de Cuenta Bancaria para Transferencias</p>
								<v-row class="mt-1">
									<v-col cols="12" md="6" class="py-0">
										<v-select
											v-model="bankAccount.bank_name"
											:items="banksList"
											label="Banco"
											outlined
											dense
											required
											:rules="requiredRule"
										></v-select>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-select
											v-model="bankAccount.account_type"
											:items="accountTypes"
											label="Tipo de Cuenta"
											outlined
											dense
											required
											:rules="requiredRule"
										></v-select>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.account_number"
											label="Número de Cuenta"
											outlined
											dense
											required
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.account_holder_name"
											label="Nombre del Titular"
											outlined
											dense
											required
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.account_holder_rut"
											label="Rut del Titular"
											outlined
											dense
											required
											hint="Ingresa rut sin puntos ni guión"
											:rules="rutRule"
											@blur="onBlurRutBank"
											@focus="onFocusRutBank"
											maxlength="9"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.email"
											label="Email"
											outlined
											dense
											required
											:rules="emailRules"
										></v-text-field>
									</v-col>
								</v-row>
							</div>
							<v-row align="center">
								<v-col cols="12">
									<div class="d-flex flex-row justify-end">
										<v-btn
											class="mx-2 my-1"
											color="white"
											raised
											@click="closeModal"
										>
											<p class="mb-0 text-primary">Cancelar</p>
										</v-btn>
										<v-btn
											class="mx-2 my-1"
											color="#524D4D"
											raised
											dark
											:loading="loadingData"
											@click="sendForm"
										>
											<p class="mb-0">Confirmar</p>
										</v-btn>
									</div>
								</v-col>
							</v-row>
						</v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {setUserBillingInfo, updateOrCreateBankAccount} from '@/helpers/api/user'
import {validate, format, clean} from '@/helpers/rut.js'

export default {
  name: 'UserBillingInfoModal',
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
		selectedTab: 1,
		newBillingInfo: {
			type: true,
			name: null,
			rut: null,
			address: null,
			state_id: null,
			district_id: null
		},
		bankAccount: {
			bank_name: null,
			account_type: null,
			account_number: null,
			account_holder_name: null,
			account_holder_rut: null,
			email: null,
			is_default: false
		},
		accountTypes: [
			'Cuenta Corriente',
			'Cuenta Vista',
			'Cuenta de Ahorro'
		],
		banksList: [
			'BANCO DE CHILE',
			'BANCO INTERNACIONAL',
			'SCOTIABANK CHILE',
			'BANCO DE CREDITO E INVERSIONES',
			'BANCO BICE',
			'HSBC BANK (CHILE)',
			'BANCO SANTANDER-CHILE',
			'BANCO ITAÚ CHILE',
			'BANCO SECURITY',
			'BANCO FALABELLA',
			'BANCO RIPLEY',
			'BANCO CONSORCIO',
			'BANCO BTG PACTUAL CHILE',
			'TANNER BANCO DIGITAL',
			'JP MORGAN CHASE BANK, N. A.',
			'CHINA CONSTRUCTION BANK, AGENCIA EN CHILE',
			'BANK OF CHINA, AGENCIA EN CHILE',
			'BANCO DEL ESTADO DE CHILE'
		],
		rutRule: [
			v => validate(v) || 'Rut no válido'
		],
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
	},
  mounted(){
		this.selectedTab = this.$store.state.general.userTypePromptModalTab || 1
		Object.assign(this.newBillingInfo, this.$store.state.user.userInfo.billing_info)
		if(this.$store.state.user.userInfo.bank_account){
			Object.assign(this.bankAccount, this.$store.state.user.userInfo.bank_account)
		}
		if(this.newBillingInfo.state_id){
			this.onChangeState(this.newBillingInfo.state_id)
		}
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		onBlurRut(){
			if(validate(this.newBillingInfo.rut)){
				this.newBillingInfo.rut = format(this.newBillingInfo.rut)
			}
		},
		onFocusRut(){
			if(validate(this.newBillingInfo.rut)){
				this.newBillingInfo.rut = clean(this.newBillingInfo.rut)
			}
		},
		onBlurRutBank(){
			if(validate(this.bankAccount.account_holder_rut)){
				this.bankAccount.account_holder_rut = format(this.bankAccount.account_holder_rut)
			}
		},
		onFocusRutBank(){
			if(validate(this.bankAccount.account_holder_rut)){
				this.bankAccount.account_holder_rut = clean(this.bankAccount.account_holder_rut)
			}
		},
		onChangeState(state){
			this.$store.dispatch('general/getCities', state)
		},
		async sendForm(){
			if(this.$refs.form.validate()){
				this.loadingData = true
				
				await Promise.all([
					this.saveBillingInfo(),
					this.saveBankAccountData()
				]);
				
				eventBus.$emit('reloadInformation')
				this.loadingData = false
				this.closeModal()
			}
		},
		async saveBillingInfo(){
			const result = await setUserBillingInfo(this.newBillingInfo)
			if(result.code === 200){
				const messageData = {
					message: 'Se ha guardado correctamente los datos de facturación',
					title: 'Datos guardados',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
				this.$store.dispatch('user/getUserInfo')
			}
			else{
				const messageData = {
					message: 'Hubo un error al guardar los datos, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async saveBankAccountData(){
			if(!this.bankAccount.bank_name) {
				return
			}

			const result = await updateOrCreateBankAccount(this.bankAccount)
			if(result.code === 200){
				const messageData = {
					message: 'Se ha guardado correctamente la cuenta bancaria',
					title: 'Cuenta bancaria guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error al guardar la cuenta bancaria, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		setMessage(messageData){
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.dispatch('general/addMessage', data)
		},
    closeModal(){
      this.$store.commit('general/setUserTypePromptModal', false)
			this.selectedTab = 1
			this.bankAccount = {
				bank_name: null,
				account_type: null,
				account_number: null,
				account_holder_name: null,
				account_holder_rut: null,
				email: null,
				is_default: false
			}
    }
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>